<template>
  <div>
    <div v-if="current === 'Login'">
      <Login :redirect="redirect" v-on:changePage="setNextPage" />
    </div>
    <div v-else-if="current === 'Dashboard'">
      <Dashboard v-on:changePage="setNextPage" />
    </div>
    <div v-else-if="current === 'EditReference'">
      <EditProvenance
        v-on:changePage="setNextPage"
        request="getProvenancesList"
        source="provenance"
      />
    </div>
    <div v-else-if="current === 'UserList'">
      <UserList v-on:changePage="setNextPage" />
    </div>
    <div v-else-if="current === 'AddNewUser'">
      <AddNewUser v-on:changePage="setNextPage" />
    </div>
    <div v-else-if="current === 'EditUser'">
      <EditUser v-on:changePage="setNextPage" />
    </div>
    <div v-else-if="current === 'Budgets'">
      <Budgets v-on:changePage="setNextPage" />
    </div>
    <div v-else-if="current === 'BuildingList'">
      <BuildingList v-on:changePage="setNextPage" />
    </div>
    <div v-else-if="current === 'AddEditBuilding'">
      <AddEditBuilding v-on:changePage="setNextPage" />
    </div>
    <div v-else-if="current === 'AddBuildingForUser'">
      <AddBuildingForUser v-on:changePage="setNextPage" />
    </div>
    <div v-else-if="current === 'AddUserForBuilding'">
      <AddUserForBuilding v-on:changePage="setNextPage" />
    </div>
    <div v-else-if="current === 'EditBuildingForUser'">
      <EditBuildingForUser v-on:changePage="setNextPage" />
    </div>
    <div v-else-if="current === 'EditUserForBuilding'">
      <EditUserForBuilding v-on:changePage="setNextPage" />
    </div>
    <div v-else-if="current === 'BuildingServices'">
      <BuildingServices v-on:changePage="setNextPage" />
    </div>
    <div v-else-if="current === 'DrTaskAssignment'">
      <DrTaskAssignment v-on:changePage="setNextPage" />
    </div>
    <div v-else-if="current === 'TaskAssignment'">
      <TaskAssignment v-on:changePage="setNextPage" />
    </div>
    <div v-else-if="current === 'GroupManagement'">
      <GroupManagement v-on:changePage="setNextPage" />
    </div>
    <div v-else-if="current === 'TaskManagement'">
      <TaskManagement v-on:changePage="setNextPage" />
    </div>
    <div v-else-if="current === 'TaskDispatcher'">
      <TaskDispatcher v-on:changePage="setNextPage" />
    </div>
    <div v-else-if="current === 'ClientTokenTable'">
      <ClientTokenTable v-on:changePage="setNextPage" />
    </div>
    <div v-else-if="current === 'Cleanup'">
      <Cleanup v-on:changePage="setNextPage" />
    </div>
    <div v-else-if="current === 'TaskBuildingList'">
      <TaskBuildingList v-on:changePage="setNextPage" />
    </div>
    <div v-else-if="current === 'TaskTable'">
      <TaskTable v-on:changePage="setNextPage" />
    </div>
    <div v-else-if="current === 'plannerGroupingList'">
      <PlannerGroupingList v-on:changePage="setNextPage" />
    </div>
    <div v-else-if="current === 'Report'">
      <Report v-on:changePage="setNextPage" />
    </div>
    <div v-else>
      <NotFound v-on:changePage="setNextPage" />
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { globalF } from "./Helpers";
import Login from "./LoginMsalV2.vue";
import NotFound from "./NotFound.vue";

//Admin
import TaskDispatcher from "./admin/TaskDashboard/TaskDispatcher.vue";
import Dashboard from "./Dashboard.vue";
import DrTaskAssignment from "./admin/TaskAssignment/DrTaskAssignment.vue";
import TaskAssignment from "./admin/TaskAssignment/TaskAssignment.vue";
import EditProvenance from './admin/ReferenceManagement/EditProvenance.vue';
import UserList from "./admin/UserManagement/UserList";
import BuildingList from "./admin/BuildingManagement/BuildingList";
import AddEditBuilding from "./admin/BuildingManagement/AddEditBuilding";
import EditUser from "./admin/UserManagement/EditUser";
import AddNewUser from "./admin/UserManagement/AddNewUser";
import EditBuildingForUser from "./admin/EditBuildingForUser";
import EditUserForBuilding from "./admin/EditUserForBuilding";
import AddBuildingForUser from "./admin/AddBuildingForUser";
import AddUserForBuilding from "./admin/AddUserForBuilding";
import Budgets from "./admin/BudgetManagement/Budget";
import BuildingServices from "./admin/BuildingServices";
import GroupManagement from "./admin/GroupManagement/GroupManagement.vue";
import TaskManagement from "./admin/TaskManagement/TaskManagement.vue";
import ClientTokenTable from "./admin/KeyManagement/ClientTokenTable.vue";
import Cleanup from "./admin/CleanUpManagement/CleanUp.vue";
//import TaskEventList from "./admin/TaskDashboard/TaskEventList.vue";
import TaskBuildingList from "./admin/TaskDashboard/TaskBuildingList.vue";
import TaskTable from "./admin/TaskDashboard/TaskTable.vue";
import Report from "./admin/ReportsManagement/ReportSelector.vue";
import PlannerGroupingList from "./admin/TaskGroupingManagement/PlannerGroupingList.vue";

export default {
  name: "module1",
  mixins: [globalF],
  props: {
    current: {
      type: String,
      default: "dashboard",
    },
    redirect: {
      type: String,
    },
  },
  mounted() {
    //Reload page in case of a 401 error
    axios.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (error.response) {
          if (error.response.status === 401) {
            this.goToLogin();
          }
        }
        return Promise.reject(error);
      }
    );
  },
  methods: {
    setNextPage(page) {
      let promise = this.validateToken();
      promise.then(() => {
        this.$emit("changePage", page);
      });
    },
  },
  components: {
    Login,
    NotFound,
    EditUser,
    AddNewUser,
    Budgets,
    EditProvenance,
    UserList,
    BuildingList,
    AddEditBuilding,
    EditBuildingForUser,
    AddBuildingForUser,
    EditUserForBuilding,
    AddUserForBuilding,
    BuildingServices,
    TaskAssignment,
    Dashboard,
    GroupManagement,
    TaskManagement,
    TaskDispatcher,
    ClientTokenTable,
    Cleanup,
    TaskBuildingList,
    TaskTable,
    DrTaskAssignment,
    Report,
    PlannerGroupingList
  },
};
</script>
